import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/lib/queryKeys';
import { maintenanceRequestLogsService } from '@/services/maintenance';

export const useMaintenanceRequestReceivableItems = (
  maintenanceRequestId: string | null,
  options?: { enabled?: boolean },
) => {
  return useQuery({
    queryKey: maintenanceRequestId
      ? queryKeys.maintenanceRequests.receivableItems(maintenanceRequestId)
      : queryKeys.maintenanceRequests.receivableItems('missing'),
    queryFn: () => {
      if (!maintenanceRequestId) {
        return Promise.resolve([]);
      }
      return maintenanceRequestLogsService.getReceivableItems(maintenanceRequestId);
    },
    enabled: Boolean(maintenanceRequestId) && (options?.enabled ?? true),
    staleTime: 30_000,
  });
};
